import React from 'react';
import why from "../../../Assets/whyaudigo.svg";

const WeWork = props => {
    return (
        <div id="we-work" className="adg-container">
            <div className="adg-header">
                Why Audigo ?
            </div>
            <div className="adg-container-data">
                <div className="adg-container-banner">
                    <img src={why} alt="work-img" />
                </div>
                <div className="adg-data">
                    <p>
                        Audigo focus on Accuracy, Timely Delivery, Cost Effective Solutions and Door Step Financial Services are our other specialties in compliance, and regulatory and corporate governance and focused professional practice providing high quality services and integrating value added knowledge, for its people, clients and society as a whole.
                    </p>
                    <p>
                        We take care of bookkeeping for small business owners. And we do it in a way that’s never been done before by pairing intuitive software with real, human bookkeepers. To us, it’s more than number crunching. It's giving entrepreneurs more time to focus on what they care about.
                    </p>
                    <p>
                        We specialize in Undertaking Direct tax support services for Multinational corporate clients. With our functional knowledge of ERP environment, these services may be provided at the clients place or at our own offices and may be suitably customized as per the requirements of each client.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default WeWork;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/WeWork/WeWork.js